import React from 'react';
import type { FC } from 'react';
import type { SelectOption } from '@wix/cli-ui-kit';
import {
  Link,
  Text,
  SelectInput,
  SelectOptionAvailability,
} from '@wix/cli-ui-kit';
import { useWixCliAppBi } from '../../../bi-app/index.js';
import { ReleaseVersionType } from './types.js';

interface ChooseVersionProps {
  nextMinor?: string;
  nextMajor: string;
  onChosen: (props: ReleaseVersionType) => void;
}

export const ChooseVersion: FC<ChooseVersionProps> = (props) => {
  const { nextMinor, nextMajor, onChosen } = props;

  const bi = useWixCliAppBi();

  const options: Array<SelectOption<ReleaseVersionType>> = [
    {
      title: nextMinor ? `Minor (${nextMinor})` : 'Minor',
      description: 'update doesn’t require Wix user consent',
      value: ReleaseVersionType.MINOR,
      availability: nextMinor
        ? SelectOptionAvailability.Enabled()
        : SelectOptionAvailability.Disabled({
            reason: (
              <Text>
                Recent changes you made require this release to be a major
                release. <Link url="https://wix.to/ZR80Y7p">Learn more</Link>
              </Text>
            ),
          }),
    },
    {
      title: `Major (${nextMajor})`,
      description: 'update requires Wix user consent',
      value: ReleaseVersionType.MAJOR,
    },
  ];

  const question = 'What type of version would you like to create?';

  return (
    <SelectInput<ReleaseVersionType>
      label={question}
      options={options}
      initialIndex={nextMinor ? 0 : 1}
      onSubmit={({ value }) => {
        bi.cliFlowStepAnswered({
          question,
          questionKey: 'release_command.version_type_question',
          answer: value,
        });
        onChosen(value);
      }}
    />
  );
};
